// extracted by mini-css-extract-plugin
export var discard = "_26-4";
export var muiTooltipTooltip = "_26-6";
export var notificationBar = "_26-3";
export var notificationContainer = "_26-2";
export var saveButtonHoverSlotWrapper = "_26-5";
export var show = "_26-1";
export var spacer = "_26-0";